import { FC } from 'react'
import cn from 'classnames'
import accounting from 'accounting'

import ChatBubble from '@/components/ChatBubble'
import { IMessage } from '@/context/types'
import {
  WORK_ORDER_PRIORITY_STYLE,
  WORK_ORDER_STATUS,
  WORK_ORDER_STATUS_STYLE,
} from '../constants'
import { DIRECTION } from '@/context/constants'

interface WorkOrderCardProps {
  message: IMessage
}

const WorkOrderCard: FC<WorkOrderCardProps> = ({ message }) => {
  return (
    <>
      <ChatBubble direction={DIRECTION.RIGHT}>
        <div className="sm:pmui-text-xs md:pmui-text-sm pmui-font-eina03 pmui-whitespace-pre-wrap">
          I need help with Work Order:
        </div>
      </ChatBubble>
      <div className="pmui-flex pmui-justify-end">
        <div
          className={cn(
            'pmui-p-3 pmui-w-72 pmui-h-40 pmui-flex pmui-flex-col pmui-flex-shrink-0 pmui-text-sm pmui-text-left pmui-rounded-lg carousel-box',
          )}
        >
          <div className="pmui-flex pmui-justify-between pmui-items-center pmui-w-full">
            <div>{message.metadata?.workOrderNumber}</div>
            <div
              className={cn(
                `pmui-px-2 pmui-py-2 pmui-rounded pmui-text-xs`,
                WORK_ORDER_STATUS_STYLE[
                  WORK_ORDER_STATUS[message.metadata?.workStatus || '']
                ],
              )}
            >
              {WORK_ORDER_STATUS[message.metadata?.workStatus || '']}
            </div>
          </div>
          <div className="pmui-w-full pmui-text-base pmui-font-semibold pmui-mt-1 pmui-flex-1">
            {message.metadata.title}
          </div>
          <div className="pmui-text-sm pmui-mb-2">
            {`${message.metadata?.street}${
              message.metadata?.unitNumber
                ? `, Unit ${message.metadata?.unitNumber}`
                : ''
            }`}
          </div>
          <div className="pmui-flex pmui-justify-between pmui-items-center pmui-w-full">
            <div className="pmui-flex pmui-items-center">
              <div
                className={cn(
                  'dot pmui-mr-2',
                  WORK_ORDER_PRIORITY_STYLE[message.metadata?.priority || ''],
                )}
              />
              <div className={'pmui-text-sm pmui-text-pop-gray-300'}>
                {message.metadata?.priority}
              </div>
            </div>
            <div className={'pmui-text-sm'}>
              Total Est:{' '}
              {accounting.formatMoney(message.metadata?.grandTotal || 0, '$')}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default WorkOrderCard
